import TermandCondition from 'app/form/TermandCondition';
import TextEditor from 'app/form/TextEditor';
import React from 'react';

const TermandConditionSection = () => {
	return (
		<div>
			<TermandCondition />
		</div>
	);
};

export default TermandConditionSection;
